import { arrayOf, bool, shape, string, func, oneOf, number, oneOfType } from 'prop-types';

// UnregisteredForm
export const unregisteredFormPropTypes = {
  form: shape({
    confirm: shape({
      label: shape({
        text: string.isRequired,
      }),
    }).isRequired,
    name: shape({
      label: string,
      label_fixed: bool,
      placeholder: string,
      message_show: bool,
      input_type: string,
      has_validation_error: bool,
      validations: arrayOf(
        shape({
          type: string,
          value: oneOfType([bool, number]),
          error_message: string,
        }),
      ),
    }),
    last_name: shape({
      label: string,
      label_fixed: bool,
      placeholder: string,
      message_show: bool,
      input_type: string,
      has_validation_error: bool,
      validations: arrayOf(
        shape({
          type: string,
          value: oneOfType([number, bool]),
          error_message: string,
        }),
      ),
    }),
    email: shape({
      label: string,
      label_fixed: bool,
      placeholder: string,
      message_show: bool,
      input_type: string,
      has_validation_error: bool,
      validations: arrayOf(
        shape({
          type: string,
          value: oneOfType([bool, number]),
          error_message: string,
        }),
      ),
    }),
    phone: shape({
      label: string,
      label_fixed: bool,
      placeholder: string,
      message_show: bool,
      input_type: string,
      has_validation_error: bool,
      validations: arrayOf(
        shape({
          type: string,
          value: string,
          error_message: string,
        }),
      ),
    }),
    identification_number: shape({
      label: string,
      label_fixed: bool,
      placeholder: string,
      message_show: bool,
      input_type: string,
      has_validation_error: bool,
      validations: arrayOf(
        shape({
          type: string,
          value: oneOfType([bool, number]),
          error_message: string,
        }),
      ),
    }),
  }).isRequired,
  url: string,
  messages: shape({
    text: string,
    type: oneOf(['success', 'error']),
    form: shape({
      title: shape({ text: string.isRequired }),
      subtitles: arrayOf(
        shape({
          text: string.isRequired,
          icon: shape({
            id: string,
            color: string,
          }),
        }),
      ),
      conditions: shape({
        text: string.isRequired,
        values: shape(),
      }),
      confirm: shape({
        label: shape({
          text: string.isRequired,
        }),
        target: string.isRequired,
        item_id: string.isRequired,
      }).isRequired,
      name: shape({
        label: string,
        label_fixed: bool,
        placeholder: string,
        message_show: bool,
        input_type: string,
        has_validation_error: bool,
        validations: arrayOf(
          shape({
            type: string,
            value: string,
            error_message: string,
          }),
        ),
      }),
      last_name: shape({
        label: string,
        label_fixed: bool,
        placeholder: string,
        message_show: bool,
        input_type: string,
        has_validation_error: bool,
        validations: arrayOf(
          shape({
            type: string,
            value: string,
            error_message: string,
          }),
        ),
      }),
      email: shape({
        label: string,
        label_fixed: bool,
        placeholder: string,
        message_show: bool,
        input_type: string,
        has_validation_error: bool,
        validations: arrayOf(
          shape({
            type: string,
            value: string,
            error_message: string,
          }),
        ),
      }),
      phone: shape({
        label: string,
        label_fixed: bool,
        placeholder: string,
        message_show: bool,
        input_type: string,
        has_validation_error: bool,
        validations: arrayOf(
          shape({
            type: string,
            value: string,
            error_message: string,
          }),
        ),
      }),
      identification_number: shape({
        label: string,
        label_fixed: bool,
        placeholder: string,
        message_show: bool,
        input_type: string,
        has_validation_error: bool,
        validations: arrayOf(
          shape({
            type: string,
            value: string,
            error_message: string,
          }),
        ),
      }),
    }),
    collapsible_info: shape({
      edit_link: shape({
        text: string.isRequired,
      }),
    }),
  }),
  privacyDisclaimer: shape({
    text: string.isRequired,
    values: shape({}),
  }).isRequired,
  recaptchaPublicKey: string,
  onSubmit: func.isRequired,
  stepBack: func,
  updateForm: func.isRequired,
  selectedUnit: shape({}).isRequired,
  selectedModel: shape({}).isRequired,
  isPostingQuotation: bool,
  model_label: shape({
    color: string,
    font_family: string,
    font_size: string,
    text: string,
  }),
  unit_label: shape({
    color: string,
    font_family: string,
    font_size: string,
    text: string,
  }),
  selection_info: shape({
    title: shape({
      text: string,
    }),
    collapsible_info: shape({
      icon: shape({
        id: string,
      }),
    }),
  }),
};
